import React from "react";
import Lottie from "react-lottie";
import "./Win_Lottie.css";
import animationData from "./Win_Lottie.json";

const Win_Lottie = () => {

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="main">
      <div className="Win_Lottie_icon">
        <Lottie
          options={defaultOptions}
        />
      </div>
    </section>
  );
};

export default Win_Lottie;